module.exports = __webpack_public_path__ + "static/RoslindaleText-Regular-67a45dae9926842b148f4f024d83f272.woff2";